var Emitter, Span, SpanBranch, SpanBuffer, SpanLeaf, assert,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SpanBranch = require('./span-branch');

SpanLeaf = require('./span-leaf');

Emitter = require('event-kit').Emitter;

assert = require('../util').assert;

Span = require('./span');

SpanBuffer = (function(superClass) {
  extend(SpanBuffer, superClass);

  function SpanBuffer(children) {
    if (children == null) {
      children = [new SpanLeaf([])];
    }
    SpanBuffer.__super__.constructor.call(this, children);
    this.isRoot = true;
    this.emitter = null;
    this.changing = 0;
    this.scheduledChangeEvent = null;
    this.scheduledChangeEventFire = null;
  }

  SpanBuffer.prototype.clone = function() {
    return SpanBuffer.__super__.clone.call(this);
  };

  SpanBuffer.prototype.destroy = function() {
    var ref;
    if (!this.destroyed) {
      this.destroyed = true;
      return (ref = this.emitter) != null ? ref.emit('did-destroy') : void 0;
    }
  };


  /*
  Section: Events
   */

  SpanBuffer.prototype._getEmitter = function() {
    var emitter;
    if (!(emitter = this.emitter)) {
      this.emitter = emitter = new Emitter;
    }
    return emitter;
  };

  SpanBuffer.prototype.onDidBeginChanges = function(callback) {
    return this._getEmitter().on('did-begin-changes', callback);
  };

  SpanBuffer.prototype.onWillChange = function(callback) {
    return this._getEmitter().on('will-change', callback);
  };

  SpanBuffer.prototype.onDidChange = function(callback) {
    return this._getEmitter().on('did-change', callback);
  };

  SpanBuffer.prototype.onDidEndChanges = function(callback) {
    return this._getEmitter().on('did-end-changes', callback);
  };

  SpanBuffer.prototype.onDidDestroy = function(callback) {
    return this._getEmitter().on('did-destroy', callback);
  };


  /*
  Section: Changing
   */

  SpanBuffer.prototype.isChanging = null;

  Object.defineProperty(SpanBuffer.prototype, 'isChanging', {
    get: function() {
      return this.changing !== 0;
    }
  });

  SpanBuffer.prototype.groupChanges = function(changeEvent, callback) {
    this.beginChanges(changeEvent);
    callback();
    return this.endChanges();
  };

  SpanBuffer.prototype.beginChanges = function(changeEvent) {
    var ref;
    this.changing++;
    if (this.changing === 1) {
      if ((ref = this.emitter) != null) {
        ref.emit('did-begin-changes');
      }
    }
    if (changeEvent) {
      assert(!this.scheduledChangeEvent, 'Can not have two scheduled change events');
      this.emitter.emit('will-change', changeEvent);
      this.scheduledChangeEvent = changeEvent;
      return this.scheduledChangeEventFire = this.changing;
    }
  };

  SpanBuffer.prototype.endChanges = function() {
    var ref;
    if (this.scheduledChangeEvent && this.scheduledChangeEventFire === this.changing) {
      this.emitter.emit('did-change', this.scheduledChangeEvent);
      this.scheduledChangeEvent = null;
      this.scheduledChangeEventFire = null;
    }
    this.changing--;
    if (this.changing === 0) {
      return (ref = this.emitter) != null ? ref.emit('did-end-changes') : void 0;
    }
  };


  /*
  Section: Characters
   */

  SpanBuffer.prototype.substr = function(location, length) {
    return this.getString().substr(location, length);
  };

  SpanBuffer.prototype.deleteRange = function(location, length) {
    if (!length) {
      return;
    }
    return this.replaceRange(location, length, '');
  };

  SpanBuffer.prototype.insertString = function(location, string) {
    if (!string) {
      return;
    }
    return this.replaceRange(location, 0, string);
  };

  SpanBuffer.prototype.replaceRange = function(location, length, string) {
    var changeEvent, slice, spanLength, start;
    if (location < 0 || (location + length) > this.getLength()) {
      throw new Error("Invalide text range: " + location + "-" + (location + length));
    }
    if (this.emitter && !this.scheduledChangeEvent) {
      changeEvent = {
        location: location,
        replacedLength: length,
        insertedString: string
      };
    }
    this.beginChanges(changeEvent);
    if (this.getSpanCount() === 0) {
      this.insertSpans(0, [this.createSpan(string)]);
    } else {
      start = this.getSpanInfoAtLocation(location);
      spanLength = start.span.getLength();
      if (start.location + length <= spanLength && length !== spanLength) {
        start.span.replaceRange(start.location, length, string);
      } else {
        slice = this.sliceSpansToRange(location, length);
        if (start.location === 0 && string.length) {
          start.span.replaceRange(0, start.span.getLength(), string);
          this.removeSpans(slice.spanIndex + 1, slice.count - 1);
        } else {
          this.removeSpans(slice.spanIndex, slice.count);
          if (string) {
            start = this.getSpanInfoAtLocation(location);
            start.span.appendString(string);
          }
        }
      }
    }
    return this.endChanges();
  };


  /*
  Section: Spans
   */

  SpanBuffer.prototype.createSpan = function(text) {
    return new Span(text);
  };

  SpanBuffer.prototype.insertSpans = function(spanIndex, spans, adjustChangeEvent) {
    var changeEvent, each, insertedString, ref, ref1;
    if (spanIndex < 0 || spanIndex > this.getSpanCount()) {
      throw new Error("Invalide span index: " + spanIndex);
    }
    if (!spans.length) {
      return;
    }
    if (this.emitter && !this.scheduledChangeEvent) {
      insertedString = ((function() {
        var i, len, results;
        results = [];
        for (i = 0, len = spans.length; i < len; i++) {
          each = spans[i];
          results.push(each.getString());
        }
        return results;
      })()).join('');
      changeEvent = {
        location: (ref = (ref1 = this.getSpan(spanIndex)) != null ? ref1.getLocation() : void 0) != null ? ref : this.getLength(),
        replacedLength: 0,
        insertedString: insertedString
      };
      if (typeof adjustChangeEvent === "function") {
        adjustChangeEvent(changeEvent);
      }
    }
    this.beginChanges(changeEvent);
    SpanBuffer.__super__.insertSpans.call(this, spanIndex, spans);
    return this.endChanges();
  };

  SpanBuffer.prototype.removeSpans = function(spanIndex, removeCount, adjustChangeEvent) {
    var changeEvent, replacedLength;
    if (spanIndex < 0 || (spanIndex + removeCount) > this.getSpanCount()) {
      throw new Error("Invalide span range: " + spanIndex + "-" + (spanIndex + removeCount));
    }
    if (!removeCount) {
      return;
    }
    if (this.emitter && !this.scheduledChangeEvent) {
      replacedLength = 0;
      this.iterateSpans(spanIndex, removeCount, function(span) {
        return replacedLength += span.getLength();
      });
      changeEvent = {
        location: this.getSpan(spanIndex).getLocation(),
        replacedLength: replacedLength,
        insertedString: ''
      };
      if (typeof adjustChangeEvent === "function") {
        adjustChangeEvent(changeEvent);
      }
    }
    this.beginChanges(changeEvent);
    SpanBuffer.__super__.removeSpans.call(this, spanIndex, removeCount);
    return this.endChanges();
  };

  SpanBuffer.prototype.getSpansInRange = function(location, length, chooseRight) {
    var range;
    if (chooseRight == null) {
      chooseRight = false;
    }
    range = this.getSpanRangeForCharacterRange(location, length, chooseRight);
    return this.getSpans(range.location, range.length);
  };

  SpanBuffer.prototype.getSpanRangeForCharacterRange = function(location, length, chooseRight) {
    var end, start;
    if (chooseRight == null) {
      chooseRight = false;
    }
    if (this.getSpanCount() === 0) {
      return {
        location: 0,
        length: 0
      };
    }
    start = this.getSpanInfoAtLocation(location, chooseRight);
    end = this.getSpanInfoAtLocation(location + length, chooseRight);
    if (end.location === 0 && end.spanIndex !== start.spanIndex) {
      end.spanIndex--;
    }
    return {
      location: start.spanIndex,
      length: (end.spanIndex - start.spanIndex) + 1
    };
  };

  SpanBuffer.prototype.getSpanInfoAtCharacterIndex = function(characterIndex) {
    if (characterIndex < this.getLength()) {
      return this.getSpanInfoAtLocation(characterIndex, true);
    } else {
      throw new Error("Invalide character index: " + characterIndex);
    }
  };

  SpanBuffer.prototype.getSpanInfoAtLocation = function(location, chooseRight) {
    var lastSpan, lastSpanIndex, spanInfo;
    if (chooseRight == null) {
      chooseRight = false;
    }
    if (location > this.getLength()) {
      throw new Error("Invalide cursor location: " + location);
    }
    if (chooseRight) {
      if (location === this.getLength()) {
        lastSpanIndex = this.getSpanCount() - 1;
        lastSpan = this.getSpan(lastSpanIndex);
        if (lastSpan) {
          spanInfo = {
            span: lastSpan,
            spanIndex: lastSpanIndex,
            location: lastSpan.getLength(),
            spanLocation: location - lastSpan.getLength()
          };
        } else {
          null;
        }
      } else {
        spanInfo = SpanBuffer.__super__.getSpanInfoAtLocation.call(this, location + 1);
        spanInfo.location--;
      }
    } else {
      spanInfo = SpanBuffer.__super__.getSpanInfoAtLocation.call(this, location);
    }
    return spanInfo;
  };

  SpanBuffer.prototype.sliceSpanAtLocation = function(location) {
    var start, startSplit;
    start = this.getSpanInfoAtLocation(location);
    if (startSplit = start.span.split(start.location)) {
      this.insertSpans(start.spanIndex + 1, [startSplit]);
    }
    return start;
  };

  SpanBuffer.prototype.sliceSpansToRange = function(location, length) {
    var end, start;
    assert(length > 0);
    start = this.sliceSpanAtLocation(location);
    if (start.location === start.span.getLength()) {
      start.spanIndex++;
    }
    end = this.sliceSpanAtLocation(location + length);
    return {
      spanIndex: start.spanIndex,
      count: (end.spanIndex - start.spanIndex) + 1
    };
  };

  SpanBuffer.prototype.replaceSpansFromLocation = function(location, spans) {
    var each, i, len, slice, totalLength;
    totalLength = 0;
    for (i = 0, len = spans.length; i < len; i++) {
      each = spans[i];
      totalLength += each.getLength();
    }
    slice = this.sliceSpansToRange(location, totalLength);
    this.removeSpans(slice.spanIndex, slice.count);
    return this.insertSpans(slice.spanIndex, spans);
  };


  /*
  Section: Debug
   */

  SpanBuffer.prototype.toString = function() {
    var spanStrings;
    spanStrings = [];
    this.iterateSpans(0, this.getSpanCount(), function(span) {
      return spanStrings.push(span.toString());
    });
    return "" + (spanStrings.join(''));
  };

  return SpanBuffer;

})(SpanBranch);

module.exports = SpanBuffer;



/*****************
 ** WEBPACK FOOTER
 ** ./lib/span-buffer/index.js
 ** module id = 10
 ** module chunks = 0
 **/